/**
 * Страница сканера QR-кодов
 * 
 * ИЗМЕНЕНО: Убрана дублирующая периодическая синхронизация сотрудников.
 * Синхронизация теперь централизована в SyncService, который использует SyncQueue
 * для предотвращения race condition.
 */
import { useEffect } from 'react'
import { Scanner } from '../components/Scanner'
import { DebugLogger } from '../components/DebugLogger'
import { AppVersion } from '../components/AppVersion'
import { useDeviceStore } from '../store/deviceStore'
import { apiClient } from '../services/apiClient'
import type { QRVerificationResult } from '../services/cryptoService'
import './ScannerPage.css'

export function ScannerPage() {
  const deviceStore = useDeviceStore()

  // Настраиваем API клиент при монтировании
  // ПРИМЕЧАНИЕ: Периодическая синхронизация сотрудников УДАЛЕНА отсюда!
  // Синхронизация централизована в SyncService для предотвращения race condition.
  useEffect(() => {
    if (deviceStore.isRegistered && deviceStore.siteId) {
      // Настраиваем API клиент
      if (deviceStore.deviceId && deviceStore.deviceSecret) {
        apiClient.setDeviceCredentials(deviceStore.deviceId, deviceStore.deviceSecret)
        console.log('[ScannerPage] API client configured for device:', deviceStore.deviceId)
      }
    } else {
      console.warn('[ScannerPage] ⚠️ Device not registered or siteId missing:', {
        isRegistered: deviceStore.isRegistered,
        siteId: deviceStore.siteId
      })
    }
  }, [deviceStore.isRegistered, deviceStore.siteId, deviceStore.deviceId, deviceStore.deviceSecret])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleScanSuccess = (result: QRVerificationResult) => {
    // Событие успешно обработано в Scanner компоненте
    // result не используется здесь, но Scanner передает его в callback
    void result // Явно указываем что параметр намеренно не используется
  }

  const handleScanError = (error: string) => {
    console.error('Scan error:', error)
  }

  // Проверяем, зарегистрировано ли устройство
  if (!deviceStore.isRegistered || !deviceStore.siteId) {
    return (
      <div className="scanner-page">
        <div className="activation-page">
          <div className="activation-card">
            <div className="activation-icon">⚠️</div>
            <h2>Устройство не активировано</h2>
            <p className="error-message">
              Это устройство ещё не активировано в системе.
            </p>
            <div className="activation-info">
              <p><strong>Что нужно сделать:</strong></p>
              <ol style={{ textAlign: 'left', marginTop: '10px' }}>
                <li>Обратитесь к администратору</li>
                <li>Получите ссылку или QR-код активации</li>
                <li>Откройте ссылку на этом планшете</li>
                <li>Следуйте инструкциям по активации</li>
              </ol>
            </div>
            <button 
              className="activation-button secondary"
              onClick={() => {
                // Проверяем localStorage на токен
                const token = localStorage.getItem('pendingActivationToken')
                if (token) {
                  window.location.href = `/activate/${token}`
                } else {
                  alert('Токен активации не найден. Отсканируйте QR-код заново.')
                }
              }}
            >
              Проверить активацию
            </button>
          </div>
        </div>
        <DebugLogger />
      </div>
    )
  }

  return (
    <div className="scanner-page">
      <div className="scanner-wrapper">
        <Scanner onScanSuccess={handleScanSuccess} onScanError={handleScanError} />
      </div>
      
      <AppVersion />
      <DebugLogger />
    </div>
  )
}





